import { Button } from "@mui/material";
import React from "react";
import { indxToAlpha } from "../../../utils/education";
import { getTranslation } from "../../../utils/webviewLang";
import { logCustomGaEvent } from "../../../utils/webviewAnalytics";

type Props = {
  polls: any;
  choices: any;
  sectionId: string;
  sectionTitle: string;
  modifyPollResponse: Function;
  submitPoll: Function;
  pageId: string;
  pageTitle: string;

  lang: string;
};

const pollModified = async (
  pageId: string,
  sectionId: string,
  pageTitle: string,
  sectionTitle: string,
  data: any
) => {
  logCustomGaEvent("em_page_poll_qn_ans_modified", {
    page_id: pageId,
    page_title: pageTitle,
    poll_id: sectionId,
    // poll_title: sectionTitle,
    ...data,
  });
};

const PollQuestion: React.FC<Props> = ({
  choices,
  sectionId,
  sectionTitle,
  polls,
  modifyPollResponse,
  submitPoll,
  pageId,
  pageTitle,
  lang,
}) => {
  const poll = polls[sectionId];
  const changeHandler = (choice: any) => {
    pollModified(pageId, sectionId, pageTitle, sectionTitle, {
      answer_id: choice.id,
      // answer_title: choice.label,
    });
    modifyPollResponse(sectionId, choice.id);
  };

  let submitted = poll?.submitted;

  return (
    <>
      <div className="question-choices">
        {choices.map((choice: any, index: number) => {
          let text = "";
          if (submitted && poll?.aggregate) {
            text = poll?.aggregate[choice.id] || "0%";
          }
          return (
            <div
              key={choice.id}
              className={
                poll?.value === choice.id
                  ? "question-choice selected"
                  : "question-choice"
              }
              onClick={() => changeHandler(choice)}
              role="button"
              tabIndex={0}
            >
              {choice.signedUrl && (
                <img
                  src={choice.signedUrl}
                  className="question-choice-image"
                  alt="choice"
                />
              )}
              <span>{indxToAlpha(index) + ". " + choice.label}</span>
              {text && <span className="aggregate">{text}</span>}
            </div>
          );
        })}
      </div>
      <Button
        sx={{
          height: "60px",
          textTransform: "none",
          my: 2,
          fontWeight: 600,
          fontSize: "1.125rem",
        }}
        variant="contained"
        fullWidth
        onClick={() => submitPoll(sectionId, sectionTitle, choices)}
      >
        {getTranslation("submit", lang)}
      </Button>
    </>
  );
};

export default PollQuestion;
